module.exports = __webpack_public_path__ + "img/course_bg5.1021c0ab.png";